import { RequestOrderDetailsData } from '../../hooks/order-details-hooks';
export var putOrderInSessionStorage = function (orderDetailsData) {
    var maxStorageSize = 5000000; // Max storage size of sessionStorage
    var orderDetailsDataString = JSON.stringify(orderDetailsData);
    var totalSize = new Blob([orderDetailsDataString]).size +
        new Blob(Object.values(sessionStorage)).size;
    if (totalSize < maxStorageSize) {
        sessionStorage.setItem('orderDetailsData', orderDetailsDataString);
    }
};
export var getOrderFromSessionStorageOrAPI = function (customerType, customerRole, requestParams, setOrderDetailsData, requestOriginatedFrom, channel) {
    if (requestParams.orderNumber) {
        var orderDetailsDataStorage = sessionStorage.getItem('orderDetailsData');
        if (orderDetailsDataStorage) {
            var orderDetailsDataInfo = JSON.parse(orderDetailsDataStorage);
            if (requestParams.orderNumber === orderDetailsDataInfo.orderNumber) {
                setOrderDetailsData(orderDetailsDataInfo);
            }
            else {
                RequestOrderDetailsData(customerType, customerRole, requestParams, setOrderDetailsData, requestOriginatedFrom, channel);
            }
        }
        else {
            RequestOrderDetailsData(customerType, customerRole, requestParams, setOrderDetailsData, requestOriginatedFrom, channel);
        }
    }
};
